import React from 'react';
import styled from 'styled-components';

interface SimpleCardProps {
  img: string;
  eyebrow?: string;
  title: string;
  desc?: string;
}

const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledCardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledEyebrow = styled.span`
  font-weight: bold;
  color: #0055ff;
  padding: 10px 0;
`;

const StyledCardImgContainer = styled.div`
  img {
    width: 100%;
  }
`;

const StyledTitle = styled.h3`
  margin: 0;
`;

const SimpleCard = ({img, eyebrow, title, desc}: SimpleCardProps) => (
  <StyledCardContainer>
    <StyledCardImgContainer>
      <img src={img} alt={title} />
    </StyledCardImgContainer>
    <StyledCardContentContainer>
      <StyledEyebrow>{eyebrow}</StyledEyebrow>
      <StyledTitle>{title}</StyledTitle>
      <p>{desc}</p>
    </StyledCardContentContainer>
  </StyledCardContainer>
);

export default SimpleCard;
